(function() {
  document.addEventListener('theme:variant:change', (event) => {
    console.log('variant changed')
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('variant', event.detail.variant.id);
    const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
    window.history.pushState({ path: newUrl }, '', newUrl);

    updateATCPrice()
  });

  window.addEventListener('stay-ai-subscription-changed', (event) => {
    updateATCPrice(event)
  })

  function updateATCPrice(event) {
    const addToCartPrice = document.querySelector('.add-to-cart-btn [x-data="AddToCartPrice"]')
    const stayCustomPriceEl = document.querySelector('.stay-custom-price')
    
    setTimeout(() => {
      const subscriptionPriceEl = document.querySelector('[data-stayai-subscription-price]')
      const oneTimePriceEl = document.querySelector('[data-stayai-onetime-price]')
      const hasSubSelected = document.querySelector('#purchaseTypeSubscription[checked]')

      if (!subscriptionPriceEl || !oneTimePriceEl || !addToCartPrice) return;
      if (stayCustomPriceEl) stayCustomPriceEl.remove();

      const priceHtml = event?.detail?.sellingPlanId === '' || !hasSubSelected
        ? oneTimePriceEl.innerHTML
        : subscriptionPriceEl.innerHTML

      const newPrice = `
        <span class="stay-custom-price">
          <span> – </span>
          <span>${stripStrikethrough(priceHtml)}</span>
        </span>
      `

      addToCartPrice.insertAdjacentHTML('afterend', newPrice)
      addToCartPrice.style.display = 'none'
    }, 0);
  }

  function stripStrikethrough(html) {
    const temp = document.createElement('div')
    temp.innerHTML = html
    temp.querySelectorAll('s, .strike-through').forEach(el => el.remove())
    return temp.innerHTML
  }
})()